import { CommonResponse } from 'models';
import axiosClient from 'utils/axiosClient';
import { DefaultPanelItem } from './model';

const defaultPanelService = {
  getList(): Promise<CommonResponse<DefaultPanelItem[]>> {
    const url = `/default-panel`;
    return axiosClient.get(url);
  },
  updateList(data: DefaultPanelItem[]): Promise<CommonResponse<DefaultPanelItem[]>> {
    const url = `/default-panel`;
    return axiosClient.put(url, data);
  },
};
export default defaultPanelService;
